<template>
  <header id="site-header" class="fixed-top">
    <div class="container-fluid">
      <nav class="navbar navbar-expand-lg stroke">
        <h1>
          <a class="navbar-brand d-flex align-items-center" href="/">
            <i class="fa mr-1" aria-hidden="true"></i>
            <img src="@/assets/newlogo.png" class="logo-icon" alt="logo" />
            <span style="padding-left: 10px;border-width: 0;">Pet Home</span>
          </a>
        </h1>
        <button class="navbar-toggler  collapsed bg-gradient" type="button" data-toggle="collapse"
          data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false"
          aria-label="Toggle navigation">
          <span class="navbar-toggler-icon fa icon-expand fa-bars"></span>
          <span class="navbar-toggler-icon fa icon-close fa-times"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
          <ul class="navbar-nav ml-lg-auto">
            <li class="nav-item active">
              <router-link class="nav-link" to="/">Home <span class="sr-only">(current)</span></router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link home-color" to="/about">About Us</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link home-color"  to="/contact">Products</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link home-color"  to="/support">Support/FAQ</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link home-color" to="/contact">Contact/Partner</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link home-color"   to="/idtags">My ID Tags</router-link>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </header>
</template>
<script>
export default {
  name: 'appHeader'
}
</script>

<script setup>
import 'bootstrap';
import $ from 'jquery';
import { onMounted } from 'vue';
window.bootstrap = require('bootstrap'); 
onMounted(() => {
  // 页面加载完成后执行
        $(window).on("scroll", function () {
            var scroll = $(window).scrollTop();
            if (scroll >= 80) {
              $("#site-header").removeClass("nav-fixed-absolute");
              $("#site-header").addClass("nav-nav-fixed-top");
              $("#site-header").addClass("nav-fixed");

            } else {
              $("#site-header").removeClass("nav-fixed-top");
              $("#site-header").addClass("nav-nav-fixed-asbolute");
                $("#site-header").removeClass("nav-fixed");
            }
        });

        //Main navigation Active Class Add Remove
        $(".navbar-toggler").on("click", function () {
            $("header").toggleClass("active");
        });
        $(document).on("ready", function () {
            if ($(window).width() > 991) {
                $("header").removeClass("active");
            }
            $(window).on("resize", function () {
                if ($(window).width() > 991) {
                    $("header").removeClass("active");
                }
            });
        });
       
}) 
</script>

<style scoped>
/* 可以添加样式 */
.navbar-nav .home-color {
  color:#977f68;
}
</style>